import { render, staticRenderFns } from "./Apartament.vue?vue&type=template&id=f6622244"
import script from "./Apartament.vue?vue&type=script&lang=js"
export * from "./Apartament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports